import { useContext } from 'react'
import { OrderSourceContext } from './OrderSourceContext'

export function useOrderSource() {
    const context = useContext(OrderSourceContext)
    if (!context) {
        throw new Error('useOrderSource must be used within OrderSourceProvider')
    }
    return context
}
